<!-- 
    This container should be used either at the top level of a screen, 
    or directly inside the DefaultLayout component. 
-->
<template>
  <div 
    :class="[
      'width-' + size,
      {'no-bottom-padding' : noBottomPadding},
      {'no-top-padding' : noTopPadding},
    ]"
    class="main-container container"
  >
    <slot/>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MainContainer',

  props: {
    /* 
    Sizes: tiny: 464px, small: 624px, smallish: 720px, medium: 972px,
    big: 1024px, large: 1190px, full: Full screen - 60px $full-width-xl-padded */
    size: {
      type: String,
      required: true,
    },
    noBottomPadding: {
      type: Boolean,
      default: false,
    },
    noTopPadding: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.main-container {
  @include media-breakpoint-down(sm) {
    /* override xs and sm to have same container width */
    max-width: 100% !important;
  }

  &.container {
    height: auto;
    padding-top: 24px;
    padding-right: 7px;
    padding-bottom: 30px;
    padding-left: 7px;

    &.no-top-padding {
      padding-top: 0;
    }

    &.no-bottom-padding {
      padding-bottom: 0;
    }

    @include media-breakpoint-up(md) {
      // At medium or up, spread wide (1400px cap)...
      max-width: #{'min(100% - 80px, 1400px)'};

      // ...unless tiny/small options
      &.width-tiny {
        max-width: 464px;
      }

      &.width-small {
        max-width: 624px;
      }
    }

    @include media-breakpoint-up(xl) {
      &.width-smallish {
        max-width: 780px;
      }

      &.width-medium {
        max-width: 972px;
      }

      &.width-big {
        max-width: 1024px;
      }

      &.width-large {
        max-width: 1190px;
      }

      &.width-full {
        max-width: #{'min(100% - 80px, 1400px)'};
      }

      padding-bottom: 64px;
    }

    @include media-breakpoint-down(sm) {
      padding-right: 0;
      padding-left: 0;
    }
  }
}
</style>
